


























































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default Vue.extend({
  name: "ForgotPasswordCard",
  components: {},
  computed: {
    ...mapGetters("auth", ["getLoadingResetPassword"]),
  },
  data(): any {
    return {
      email: "",
      hasResetPassword: false,
    };
  },
  methods: {
    ...mapActions("auth", ["resetPassword"]),
    ...mapMutations("snackbar", ["toastSuccess"]),
    async onResetPassword() {
      const payload = {
        email: this.email,
      };
      this.hasResetPassword = await this.resetPassword(payload);

      if (this.hasResetPassword) {
        this.toastSuccess({ message: this.$t("forgotPassword.success") });
      }
    },
  },
});
